import { useAppSelector } from 'hooks/redux.hooks';
import { selectImageUrl } from 'state/reducers/translation.reducers';
//theme
import { CenteredContent, CenteredText } from 'theme/elements/Content';
import { Box, Stack, Typography, styled } from '@mui/material';

export type propsType = {
  title?: string;
  imageKey?: string;
};

export default function WaitingMessage(props: propsType) {
  const imageUrl = useAppSelector(selectImageUrl);

  return (
    <CenteredContent>
      <CenteredText>
        <Stack spacing={1}>
          <Box>
            <img src={imageUrl(props.imageKey || '') || '/icons/altshuler.svg'} alt="" />
          </Box>
          {/* <Typography variant="h4">{props.title}</Typography> */}
          <Stack
            direction="row"
            spacing={1}
            justifyContent="space-around"
            sx={{ width: '50px', margin: '18px auto!important' }}
          >
            <Dot />
            <Dot className="dot2" />
            <Dot className="dot3" />
          </Stack>
        </Stack>
      </CenteredText>
    </CenteredContent>
  );
}

const Dot = styled(Box)((props) => ({
  width: '12px',
  height: '12px',
  borderRadius: '8px',
  background: '#e7edee',
  animation: `myEffect 1s infinite`,
  animationDelay: '0.0s',
  '&.dot2': {
    animationDelay: '.2s',
  },
  '&.dot3': {
    animationDelay: '.4s',
  },
  '@keyframes myEffect': {
    '0%': {
      background: '#e3672a',
    },
    '50%': {
      background: '#e7edee',
    },
    '75%': {
      background: '#e3672a',
    },
    '100%': {
      background: '#e3672a',
    },
  },
}));
